import type { CSSProperties } from "react";

export interface SkeletonProps {
  /** 줄 개수. 들어올 목록의 길이만큼 잡아 두면 응답이 와도 화면이 안 튄다. */
  rows?: number;
  /** 한 줄 높이(px). 기본값은 `ListCell` 한 줄과 같다. */
  height?: number;
  className?: string;
  style?: CSSProperties;
}

/** 목록 자리 표시자.
 *
 *  가운데 스피너를 쓰지 않는 이유: 스피너는 자리를 안 잡아서 응답이 오는 순간
 *  아래 내용이 통째로 밀린다(누르려던 버튼이 도망간다). 스켈레톤은 들어올
 *  모양을 미리 차지한다.
 *
 *  움직임을 줄여 달라고 한 사용자에게는 반짝임만 멈춘다 — 자리는 그대로다
 *  (`.maky-skeleton`, styles/maky-interactions.css). */
export function Skeleton({ rows = 3, height = 44, className, style }: SkeletonProps) {
  return (
    // <output> 는 암묵 role 이 status 다 — div + role="status" 보다 마크업이 정직하다.
    <output
      aria-busy="true"
      aria-label="불러오는 중"
      className={className}
      style={{ display: "flex", flexDirection: "column", gap: 8, ...style }}
    >
      {Array.from({ length: rows }, (_, i) => (
        <div
          // 자리 표시자는 순서 말고 정체성이 없다.
          key={i}
          className="maky-skeleton"
          style={{
            height,
            // 줄마다 길이를 조금씩 달리해야 "목록" 으로 읽힌다. 난수가 아니라
            // 고정 패턴이다 — 다시 그릴 때마다 길이가 바뀌면 그게 더 시끄럽다.
            width: `${100 - (i % 3) * 8}%`,
          }}
        />
      ))}
    </output>
  );
}

export default Skeleton;
